import { useTranslation } from 'react-i18next';

import { CustomSwitch } from '@/features/canvas/components/CustomSwitch';
import { FilteredNodes, useEditorContext } from '@/features/canvas/contexts/editor-context';

const MultiFilterToggle = () => {
  const {
    isMultiFilterEnabled,
    setIsMultiFilterEnabled,
    setActiveFilterIds,
    setOptionCheckedIds,
    showDependencies,
    setShowDependencies,
    roadmapNodes,
    setFilteredNodes,
    hiddenChildNodeIds,
    isPublicView,
  } = useEditorContext();
  const { t } = useTranslation();

  const handleMultiFilterToggle = () => {
    setIsMultiFilterEnabled(prev => {
      const newState = !prev;

      if (newState && showDependencies) {
        setShowDependencies(false);
      }

      setActiveFilterIds([]);
      setOptionCheckedIds([]);

      // Apply the KON-145 child-hiding logic when resetting filteredNodes
      const resetNodes = roadmapNodes.map(node => ({
        ...node,
        color: '',
        shape: 'circle' as const,
        size: undefined,
      }));

      // Filter out hidden child nodes unless in public view
      const filteredResetNodes = isPublicView
        ? resetNodes
        : resetNodes.filter(node => node.id && !hiddenChildNodeIds.has(node.id));

      setFilteredNodes(filteredResetNodes as FilteredNodes[]);

      return newState;
    });
  };

  return (
    <div className="flex flex-col items-center space-y-4 mt-4 w-full">
      <div className="border-t border-gray-300 w-full" />
      <div className="flex items-center justify-between w-full px-4">
        <CustomSwitch
          isChecked={isMultiFilterEnabled}
          onChange={handleMultiFilterToggle}
          labelLeft={t('editor.filter_sidebar.single')}
          labelRight={t('editor.filter_sidebar.multiple')}
        />
      </div>
      <div className="border-t border-gray-300 w-full" />
    </div>
  );
};

export default MultiFilterToggle;
